import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import {
  FeatureDiscoveryStepperComponent,
  FeatureDiscoveryStepperComponentI,
} from '@core/feature-discovery-ui';
import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { UserInvitationCacheService } from '@core/tellent-logic';
import {
  ButtonComponent,
  CheckboxComponent,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

type StartPreonboardingJourneyDialogResult = {};

@Component({
  selector: 'tla-journey-promo-dialog',
  imports: [
    DialogBodyComponent,
    TranslatePipe,
    DialogFooterComponent,
    ButtonComponent,
    IconComponent,
    HeadingComponent,
    NgOptimizedImage,
    CheckboxComponent,
    ReactiveFormsModule,
    FeatureDiscoveryStepperComponent,
  ],
  templateUrl: './journeys-promo-dialog.component.html',
  styleUrl: './journeys-promo-dialog.component.less',
})
export class JourneysPromoDialogComponent extends DialogComponent<
  any,
  StartPreonboardingJourneyDialogResult
> {
  private readonly t = injectTranslate();
  private readonly userInvitationCacheService = inject(UserInvitationCacheService);

  protected readonly learnMoreLink = 'https://support.tellent.com/collections/10660354';
  protected readonly steps: FeatureDiscoveryStepperComponentI[] = [
    {
      heading: this.t('tlc.members.journeys_promo_dialog.steps.step_1.heading'),
      content: this.t('tlc.members.journeys_promo_dialog.steps.step_1.content'),
    },
    {
      heading: this.t('tlc.members.journeys_promo_dialog.steps.step_2.heading'),
      content: this.t('tlc.members.journeys_promo_dialog.steps.step_2.content'),
    },
    {
      heading: this.t('tlc.members.journeys_promo_dialog.steps.step_3.heading'),
      content: this.t('tlc.members.journeys_promo_dialog.steps.step_3.content'),
    },
  ];
  protected dontShowAgainControl: FormControl<boolean> = new FormControl<boolean>(false, {
    nonNullable: true,
  });

  public cancel(): void {
    this.dialogRef.close();
  }

  public continue(): void {
    if (this.dontShowAgainControl.value)
      this.userInvitationCacheService
        .setJourneysPromoDialogFlag()
        .then(() => this.dialogRef.close({}));

    this.dialogRef.close({});
  }
}
